module.exports = __webpack_public_path__ + "static/assets/0a0eb1af384d2f241aab5631440b2a33.svg";